!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("classToggler", [], e) : "object" == typeof exports ? exports.classToggler = e() : t.classToggler = e();
}(this, function () {
  return function (t) {
    var e = {};
    function n(o) {
      if (e[o]) return e[o].exports;
      var r = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(o, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 2);
  }([function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  },, function (t, e, n) {
    (function (n) {
      var o, r, i;
      void 0 !== n || this.window || this.global, r = [], o = function () {
        "use strict";

        var t = {},
          e = function e(t) {
            t.addEventListener("click", n), t.getAttribute("data-toggle-self") && t.addEventListener("click", function () {
              t.classList.toggle(t.getAttribute("data-toggle-self"));
            });
          },
          n = function n(t) {
            var e = t.currentTarget.getAttribute("data-toggle"),
              n = t.currentTarget.getAttribute("data-toggle-class"),
              o = document.getElementsByClassName(e);
            o.length > 0 ? (o[0].classList.toggle(n), t.stopPropagation()) : console.warn("classToggler error: Cannot find element with class " + e);
          };
        return t.init = function () {
          for (var t = document.querySelectorAll("[data-toggle]"), n = 0; n < t.length; n++) {
            e(t[n]);
          }
        }, t;
      }(), void 0 === (i = "function" == typeof o ? o.apply(e, r) : o) || (t.exports = i);
    }).call(this, n(0));
  }]);
});